import Sentry from "@similarweb/sentry-logger";

import { TEAMS } from "app/constants/teamName";

const BASE_URL = "api/cello";

interface CelloData {
    ProductId: string;
    Token: string;
}

export const getCelloData = async (): Promise<CelloData | null> => {
    try {
        const response = await fetch(`${BASE_URL}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
        });

        if (!response.ok) {
            throw new Error(`CelloIntegration HTTP error. status: ${response.status}`);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        Sentry.errorTracker({
            message: "CelloIntegration: error on getCelloData",
            e: error,
            level: "error",
            params: {
                tags: { team: TEAMS.HAWKS },
            },
        });
        return null;
    }
};
